import { INDUSTRIES, studiesByIndustry } from "@/content/case-studies";
import { CaseStudyCard } from "./case-study-card";
import { IndustryRail } from "./industry-rail";
import { useIndustryScrollSpy } from "./useIndustryScrollSpy";

// Desktop (>=1024): the section scrolls normally. A sticky left rail scroll-spies
// (advances Consumer Goods -> DTC -> Dental as you scroll), beside full-width
// 2-column card grids that auto-flow per industry (CPG 4, DTC 6, Dental 4).
// Nothing is pinned, so the grids never clip at any viewport height.
export function RailedCaseStudies() {
  const { containerRef, activeIndex } = useIndustryScrollSpy(INDUSTRIES.length);

  return (
    <section id="case-studies" className="py-24">
      <header className="mb-16 text-center">
        <h2 className="mb-4 font-body text-lg font-light text-foreground">
          CASE STUDIES
        </h2>
        <p className="font-heading text-4xl text-foreground xl:text-5xl">
          Selected Work
        </p>
      </header>

      <div className="mx-auto grid max-w-[1380px] grid-cols-[190px_1fr] gap-10 px-10">
        {/* Sticky scroll-spy rail (clears the fixed nav via top offset) */}
        <div>
          <div className="sticky top-32">
            <IndustryRail activeIndex={activeIndex} />
          </div>
        </div>

        {/* Stacked industry blocks, each a full-width 2-column grid,
            separated by a thin divider line. */}
        <div ref={containerRef} className="flex flex-col">
          {INDUSTRIES.map((industry, i) => (
            <div
              key={industry.id}
              data-industry-index={i}
              className="grid grid-cols-2 gap-5 border-t border-[#353739] pt-12 mt-12 first:mt-0 first:border-t-0 first:pt-0"
            >
              {studiesByIndustry(industry.id).map((study) => (
                <CaseStudyCard key={study.slug} study={study} />
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
